import { withStyles } from '@material-ui/core/styles'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import React from 'react'
import { TRACKING_TYPES } from '../constants'
import styles from './styles'

const Body = ({ setTrackingType, setShowCodesExplanationPage, classes }) => {
  return (
    <div>
      <div className={classes.trackingTypesBlock}>
        <div
          onClick={() => setTrackingType(TRACKING_TYPES.BASIC)}
          className={classes.trackingTypeButton}
        >
          <div className={classes.trackingBlockHeader}>Basic Tracking</div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.content}>
              <div className={classes.list}>
                <div className={classes.point} />
                <div>
                  Simple to do and manage. Provide only one code for each city
                  in your campaign.
                </div>
              </div>
            </div>
            <div className={classes.content}>
              <div className={classes.list}>
                <div className={classes.point} />
                <div>
                  When customers use the redemption code on the flyer, you only
                  have to track how many conversions you get using the code.
                </div>
              </div>
            </div>
          </div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.subheader}>Who is this option for?</div>
            <div className={classes.content}>
              You don't care too much about tracking precise mission & location
              performance
            </div>
            <div className={classes.content}>
              You are currently unable to provide unique codes for each mission,
              but can provide one code for the entire campaign.
            </div>
          </div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.subheader}>Tracking</div>
            <div className={classes.content}>
              We track individual performance using our proprietary technology
              and dedicated workforce, but with reduced accuracy.
            </div>
          </div>
        </div>
        <div
          // onClick={() => setTrackingType(TRACKING_TYPES.ADVANCED)}
          className={classes.trackingTypeButtonDisabled}
        >
          <div className={classes.trackingBlockHeader}>Advanced Tracking</div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.content}>
              <div className={classes.list}>
                <div className={classes.point} />
                <div>
                  Provide unique codes for each mission in your campaign.
                </div>
              </div>
            </div>
            <div className={classes.content}>
              <div className={classes.list}>
                <div className={classes.point} />
                <div>
                  When customers use the redemption codes on the flyer, you have
                  to keep track of how many conversions you get with each unique
                  code.
                </div>
              </div>
            </div>
          </div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.subheader}>Who is this option for?</div>
            <div className={classes.content}>
              You want the highest level of accuracy of performance on a mission
              and location basis.
            </div>
            <div className={classes.content}>
              You are able to generate a unique code for each mission in your
              campaign and provide us with conversion results for all these
              codes as the campaign is running.
            </div>
          </div>
          <div className={classes.trackingBlockContent}>
            <div className={classes.subheader}>Tracking</div>
            <div className={classes.content}>
              By providing unique codes, we are able to gain deep insight into
              how each mission is performing. This further helps us to optimise
              your campaign by continually re-evaluating what days, times and
              locations generate the highest results for you.
            </div>
          </div>
        </div>
      </div>
      <div
        className={classes.footer}
        onClick={() => {
          setShowCodesExplanationPage(true)
        }}
      >
        <div className={classes.infoIconBlock}>
          <InfoOutlinedIcon className={classes.infoIcon} />
        </div>
        <div className={classes.footerText}>
          What exactly are codes and how do they work? Click here for an
          explanation.
        </div>
      </div>
    </div>
  )
}
export default withStyles(styles)(Body)
